var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChvron = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 48,
    viewBox: "0 0 20 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9713 24.2211L7.72127 30.4711C7.69223 30.5002 7.65776 30.5232 7.61983 30.5389C7.58189 30.5546 7.54123 30.5627 7.50017 30.5627C7.45911 30.5627 7.41845 30.5546 7.38052 30.5389C7.34258 30.5232 7.30811 30.5002 7.27908 30.4711C7.25005 30.4421 7.22701 30.4076 7.2113 30.3697C7.19559 30.3318 7.1875 30.2911 7.1875 30.2501C7.1875 30.209 7.19559 30.1683 7.2113 30.1304C7.22701 30.0925 7.25005 30.058 7.27908 30.029L13.308 24.0001L7.27908 17.9711C7.22044 17.9125 7.1875 17.833 7.1875 17.7501C7.1875 17.6671 7.22044 17.5876 7.27908 17.529C7.33772 17.4703 7.41725 17.4374 7.50017 17.4374C7.5831 17.4374 7.66263 17.4703 7.72127 17.529L13.9713 23.779C14.0003 23.808 14.0234 23.8424 14.0391 23.8804C14.0548 23.9183 14.0629 23.959 14.0629 24.0001C14.0629 24.0411 14.0548 24.0818 14.0391 24.1197C14.0234 24.1577 14.0003 24.1921 13.9713 24.2211Z",
    fill: "#4D5F6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChvron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chvron.91c3eeb1b9f845e94b1a2e62436dd9d8.svg";